import React, { Fragment } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import projectLogo from '../../assets/images/react.svg';
import axios from 'axios';
import Qs from 'qs';
import Swal from 'sweetalert2';

import {
    Button,  UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu, Input, Form, Label, NavLink, Badge
} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserAccounts from 'uos_admin/allUsers'
import HeroImages from 'uos_admin/heroImages';
import AboutUs from 'uos_admin/aboutUs';
import { getFileUploadUI } from '../uosFileAction'
import InfoEditor from 'uos_admin/infoEditor';

export default class MainLayOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSideBar: 1, view_single_post: null, current_pid: "0", headerSearchHover: false, searchValue: "", gridTemplateColumns: "",
            mainContentPadding: false, headers: [], headerDrawerToggle: false, sidebarToggle: false, sidebarToggleMobile: false, sidebarToggleMobile: false, sidebarFixed: true, headerFixed: true
        }
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.toggleSidebarMobile = this.toggleSidebarMobile.bind(this);
    }

    toggleSidebar() {
        this.setState({ sidebarToggle: !this.state.sidebarToggle });
    }

    toggleSidebarMobile() {
        this.setState({ sidebarToggleMobile: !this.state.sidebarToggleMobile });
    }

    handleSideBarAction(e, value) {
        if (e !== null) {
            e.preventDefault();
        }
        this.setState({ activeSideBar: value, view_single_post: null });
    }

    handleViewSingleEvent(id) {
        this.setState({ view_single_post: id });
    }

    handleSearchKeyDown = (e) => {
        if (e.key === "Enter" && e.target.value !== "") {
            this.setState({ searchValue: e.target.value });
        }
    };

    handleSearchKeyChange = (e) => {
        if (e.target.value === "") {
            this.setState({ searchValue: e.target.value });
        }
    };

    handLogoutAction() {
        Swal.fire({
          title: "Sign Out!",
          text: "Are you sure?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.value) {
            window.localStorage.setItem('ch_admin_isLogin', "0")
            window.localStorage.setItem('ch_admin_token', "")
            window.localStorage.setItem('ch_admin_uname', "")
            window.localStorage.setItem('ch_admin_uid', "")
            window.localStorage.setItem('ch_admin_uimage', "")
            window.location.href = "#/";
          }
        });
      }


    render() {
        let session = window.localStorage;
        let uname = session.ch_admin_uname;
        let uimage = session.ch_admin_uimage;
        return (
            <Fragment>
                <div className={clsx('app-wrapper', 'bg-gray-500', {
                    'header-drawer-open': this.state.headerDrawerToggle,
                    'app-sidebar-collapsed': this.state.sidebarToggle && !this.state.sidebarToggleMobile,
                    'app-sidebar-mobile-open': this.state.sidebarToggleMobile,
                    'app-sidebar-fixed': this.state.sidebarFixed,
                    'app-header-fixed': this.state.headerFixed
                })}>
                    <div name="sider">
                        <div className={clsx('app-sidebar', "app-sidebar--dark", {
                            'app-sidebar--shadow': this.state.sidebarShadow
                        })}>
                            <div className="app-sidebar--header">
                                <div className="nav-logo">
                                    <Link
                                        to="/"
                                        title="">
                                        <i>
                                            <img
                                                alt=""
                                                src={projectLogo}
                                            />
                                        </i>
                                        <span style={{ color: "white" }}>{"HuaXia Chorus"}</span>
                                    </Link>
                                </div>
                                <button
                                    className={clsx(
                                        'navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn',
                                        { 'is-active': this.state.sidebarToggleMobile }
                                    )}
                                    onClick={this.toggleSidebarMobile}>
                                    <span className="hamburger-box">
                                        <span className="hamburger-inner" />
                                    </span>
                                </button>
                                <button
                                    onClick={this.toggleSidebar}
                                    className="expand-sidebar-btn btn btn-sm"
                                    id="ExpandSidebarTooltip">
                                    <FontAwesomeIcon icon={['fas', 'arrows-alt-h']} />
                                </button>
                            </div>
                            <div className="app-sidebar--content">
                                <PerfectScrollbar>
                                    <div className="sidebar-navigation">
                                        <ul>
                                            {/* <li>
                                                <Link to="/post_editor/0" target="_blank" className="sidebar-item-a">
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'plus']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">New Event</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <a href="" onClick={(e) => this.handleSideBarAction(e, 0)} className={this.state.activeSideBar === 0 ? "sidebar-item-a active" : "sidebar-item-a"}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'calendar']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Events</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li> */}
                                            <li>
                                                <a href="#/" onClick={(e) => this.handleSideBarAction(e, 1)} className={this.state.activeSideBar === 1 ? "sidebar-item-a active" : "sidebar-item-a"}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'user']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Members</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 2 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 2)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'image']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Hero Images</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href="#/" className={this.state.activeSideBar === 4 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 4)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'folder']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Resources</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li> */}
                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 3 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 3)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'info-circle']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">About Us</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 30 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 30)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'book']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">By Laws</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 31 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 31)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'file-alt']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Regulations</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>



                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 50 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 50)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'donate']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Donation Introduction</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>

                                            <li>
                                                <a href="#/" className={this.state.activeSideBar === 51 ? "sidebar-item-a active" : "sidebar-item-a"} onClick={(e) => this.handleSideBarAction(e, 51)}>
                                                    <span className="sidebar-icon"><FontAwesomeIcon icon={['fas', 'donate']} className="mx-auto" style={{ fontSize: "20px" }} /></span>
                                                    <span className="sidebar-item-label">Donation Letter</span>
                                                    <span className="sidebar-icon-indicator"></span>
                                                </a>
                                            </li>

                                        </ul>
                                    </div>
                                </PerfectScrollbar>
                            </div>
                        </div>
                        <div onClick={this.toggleSidebarMobile}
                            className={clsx('app-sidebar-overlay', {
                                'is-active': this.state.sidebarToggleMobile
                            })}
                        />
                    </div>
                    <div className="app-main">
                        <div
                            className={clsx('app-header', {
                                'app-header--shadow': this.state.headerShadow,
                                'app-header--opacity-bg': this.state.headerBgTransparent
                            })}>
                            <div className="app-header--pane">
                                <button className={clsx(
                                    'navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn',
                                    { 'is-active': this.state.sidebarToggleMobile }
                                )}
                                    onClick={this.toggleSidebarMobile}>
                                    <span className="hamburger-box">
                                        <span className="hamburger-inner" />
                                    </span>
                                </button>
                                <div className={clsx("ml-2 search-wrapper search-wrapper--alternate", { 'is-active': this.state.headerSearchHover })}>
                                    <span className="icon-wrapper text-black">
                                        <FontAwesomeIcon icon={['fas', 'search']} />
                                    </span>
                                    <Input id="main_body_search" key="main_body_search" onFocus={(e) => this.setState({ headerSearchHover: true })} onBlur={(e) => this.setState({ headerSearchHover: false })} onKeyPress={(e) => this.handleSearchKeyDown(e)} onChange={(e) => this.handleSearchKeyChange(e)} className="rounded-pill" placeholder={"Search..."} type="search" />
                                </div>
                            </div>
                            <div className="app-header--pane">
                                <UncontrolledDropdown className="user-box position-relative ml-2">
                                    <DropdownToggle
                                        color="link"
                                        className="p-0 text-left d-flex align-items-center">
                                        <div className="d-block p-0 avatar-icon-wrapper">
                                            <Badge color="success" className="badge-circle p-top-a">
                                                Online
                                            </Badge>
                                            <div className="avatar-icon rounded" style={{ width: '30px', height: "30px" }} >
                                                <img alt="..." src={uimage.startsWith("data") ? uimage : (`${window.location.origin.toString()}` + "/" + uimage + "?time=" + (new Date()).getTime())} />
                                            </div>
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu right className="dropdown-menu-lg overflow-hidden p-0">
                                        <ul className="list-group list-group-flush text-left bg-transparent">
                                            <li className="list-group-item rounded-top">
                                                <div style={{ textAlign: 'center' }} >
                                                    <div className="avatar-icon-wrapper avatar-icon-xl">
                                                        <div className="avatar-icon rounded-circle" style={{ width: '100px', height: "100px" }}>
                                                            <img alt="..." src={uimage.startsWith("data") ? uimage : (`${window.location.origin.toString()}` + "/" + uimage + "?time=" + (new Date()).getTime())} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'center' }} >
                                                    {uname}
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="card-footer bg-white p-3 text-center d-block">
                                            <Button
                                                onClick={() => this.handLogoutAction()}
                                                size="sm"
                                                outline
                                                color="danger"
                                                className="ml-1"
                                                title="Sign out">
                                                {"Sign Out"}
                                            </Button>
                                        </div>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>

                        <div className="app-content">
                            <div className="card-box bg-white p-0" style={{ height: "100%" }}>
                                <div className="main_content_class bg-secondary pt-2" style={{ height: "100%" }}>
                                    <PerfectScrollbar id="main_content_div_scroll" options={{ suppressScrollX: true, wheelPropagation: true }} >
                                        {this.state.activeSideBar === 1 && <UserAccounts />}
                                        {this.state.activeSideBar === 2 && <HeroImages />}
                                        {this.state.activeSideBar === 3 && <AboutUs />}
                                        {/* {this.state.activeSideBar === 0 && this.state.view_single_post === null && <EventsList handleViewSingleEvent={(id) => this.handleViewSingleEvent(id)} root_user={1} searchValue={this.state.searchValue} />} */}
                                        {/* {this.state.view_single_post && <SingleEventProfile id={this.state.view_single_post} />} */}
                                        {/* {this.state.activeSideBar === 4 &&<FileInstance pid={this.state.current_pid} searchValue={this.state.searchValue} is_admin={1} show_search_bar={false} />} */}
                                        {(this.state.activeSideBar === 50 || this.state.activeSideBar === 51 || this.state.activeSideBar === 30 || this.state.activeSideBar === 31) && <InfoEditor option={this.state.activeSideBar} />}
                                    </PerfectScrollbar>
                                </div>
                            </div>
                            {getFileUploadUI()}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
